import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ColumnHeader } from 'src/app/models/column-header';
import { SrcPath } from 'src/app/constants/srcPath';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { isBlank, isData, isPresent, booleanOptions } from 'src/app/utils/utils';
import { CommonService } from 'src/app/services/common-service/common.service';
import { iconListOptions } from 'src/app/utils/utils';
import { RoutePath } from 'src/app/constants/routerPath';
import { Labels } from 'src/app/constants/labels';
import { KEYS } from 'src/app/constants/keys';
import { NgSelectComponent } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-create-module',
  templateUrl: './create-module.component.html',
  styleUrls: ['./create-module.component.scss'],
  imports: [CommonModule, NgSelectComponent, FormsModule, ReactiveFormsModule, SharedModule]
})
export class CreateModuleComponent implements OnInit {
  createModuleForm: FormGroup | any;
  iconListOption = iconListOptions;
  headerData: ColumnHeader | any;
  srcPath = SrcPath;
  routePath = RoutePath;
  inputMode: any;
  parent_menu_id: any = 0;
  type_of_menu: any = 0;
  menuPageId: any = '';
  pageId: any = '';
  appId: any = 1;
  menuLink: boolean = false;
  labelMessages = Labels.messages;
  labelName = Labels.labels;
  labelModule = Labels.module;
  labelIconStyle = Labels.iconStyle;
  labelbuttons = Labels.buttons;
  appName: any = '';
  menuType: any;
  menuId: any;
  menuName: any;
  menuIcon: any;
  public appPageList: any = [];
  isSuperaDmin: boolean = false;
  dbPath: any;
  moduleName = Labels.module.module_name;
  moduleorderId: any;
  pagetype: any;
  booleanOptions = booleanOptions;
  isHide: any = 'false';
  messageLabel = Labels.messages;
  constructor(private formBuilder: FormBuilder,
    private commonService: CommonService,
    private router: Router,
    private toastr: ToastrService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.isSuperAdmin();
    this.initColumnHeader();
    this.initPageForm();
    this.loadAppPageList();
  }
  isSuperAdmin() {
    const sessionSuperAdmin = sessionStorage.getItem(KEYS.isSuperAdmin);
    if (sessionSuperAdmin)
      this.isSuperaDmin = JSON.parse(sessionSuperAdmin);
    if (this.isSuperaDmin) {
      const sessionCustomerPath = sessionStorage.getItem(KEYS.customerDbPath);
      if (sessionCustomerPath)
        this.dbPath = JSON.parse(sessionCustomerPath);
    }
  }
  initColumnHeader() {
    this.route.queryParams.subscribe(params => {
      let menuDetails;
      let moduleOrderId: any = 0;
      this.inputMode = params['inputMode'];
      if (this.inputMode != KEYS.actionType.add) {
        menuDetails = JSON.parse(params['menuDetails']);
        this.commonService.ogLog(menuDetails);

        if (isPresent(params['moduleorder'])) {
          moduleOrderId = JSON.parse(params['moduleorder']);
        }
      }
      this.menuId = this.inputMode == KEYS.actionType.add ? '' : menuDetails['gstibo_menu_id'];
      this.menuName = this.inputMode == KEYS.actionType.add ? '' : menuDetails['gstibo_menu_name'];
      this.menuIcon = this.inputMode == KEYS.actionType.add ? this.labelName.default_icon : menuDetails['gstibo_menu_icon'];
      this.menuLink = menuDetails['gstibo_page_id'] > KEYS.menuParent.defaultID ? true : false;
      this.menuPageId = this.inputMode == KEYS.actionType.add ? '' : (menuDetails['gstibo_page_id'] == null ? menuDetails['pgid'] : menuDetails['gstibo_page_id']);
      this.moduleorderId = this.inputMode == KEYS.actionType.add ? '' : (moduleOrderId['moduleorderId'] == null ? menuDetails['moduleorderId'] : moduleOrderId['moduleorderId']);
      this.isHide = this.inputMode == KEYS.actionType.add ? 'false' : (menuDetails['gstibo_is_hide'] == '1' ? 'true' : 'false');
      //  
      //  this.createModuleForm = this.formBuilder.group({
      //   isHide: [this.isHide]
      // });
      if (isPresent(menuDetails['pagetype'])) {
        this.pagetype = menuDetails['pagetype'];
      }
      else {
        this.pagetype = 'D'
      }
    });
    const pageTitle = this.inputMode == KEYS.actionType.add ? this.labelModule.create_module : this.labelModule.edit_module;
    this.headerData = {
      title: pageTitle,
      button: {
        show: false
      },
      topButton: {
        show: true,
        property: [
          {
            title: this.labelbuttons.back_menu,
            icon: SrcPath.previousIcon,
            class: this.labelIconStyle.eleven
          },
          {
            title: this.labelbuttons.save_module,
            icon: SrcPath.saveIcon,
            class: this.labelIconStyle.nine
          }
        ]
      }
    };
  }
  initPageForm() {
    let pageId = this.menuLink == true ? parseInt(this.menuPageId) : this.menuPageId;
    this.createModuleForm = this.formBuilder.group({
      menuId: [this.menuId],
      menuName: [this.menuName, Validators.required],
      menuIcon: [this.menuIcon],
      menuLink: [this.menuLink],
      menuPageID: [pageId],
      moduleorderId: this.moduleorderId,
      isHide: [this.isHide]
    });
  }

  onSubmit() {
    let subMenuPageId = 0
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    if (this.createModuleForm.valid) {
      if (this.inputMode == KEYS.actionType.add) {
        this.commonService.createModule(
          dbFullPath,
          this.createModuleForm.value.menuName,
          this.parent_menu_id,
          this.type_of_menu,
          this.createModuleForm.value.menuIcon,
          this.createModuleForm.value.menuPageID,
          this.commonService.getUserCredentials(KEYS.credential_customer_id),
          this.createModuleForm.value.isHide, this.createModuleForm.value.moduleorderId).subscribe((data: any) => {
            //this.toastr.success(this.labelMessages.save_success_msg.message);
            this.commonService.showModalValidate(this.labelMessages.save_success_msg.message,'',this.messageLabel.static_messages.info,this.labelMessages.save_success_msg.message);
            this.commonService.ogLog('moduleadd', this.createModuleForm.value);
            let moduleid = data['table'][0]['gstibo_menu_id']



            this.commonService.ogLog('moduleid', moduleid);
            if (moduleid > 0) {
              this.commonService.add_Update_MenuOrderList(moduleid, moduleid, this.createModuleForm.value.moduleorderId,
                KEYS.menuParent.defaultID, 'D', 'Y', this.createModuleForm.value.isHide, 0).subscribe((data: any) => {
                });
            }
            this.router.navigate([this.routePath.dashboard]);
          });

      } else {
        this.commonService.updateModule(
          dbFullPath,
          this.createModuleForm.value.menuId,
          this.createModuleForm.value.menuName,
          this.createModuleForm.value.menuIcon,
          this.createModuleForm.value.menuPageID,
          KEYS.menuParent.defaultID,
          this.commonService.getUserCredentials(KEYS.credential_customer_id),
          this.createModuleForm.value.isHide,
          this.createModuleForm.value.moduleorderId).subscribe((data: any) => {
           //this.toastr.success(this.labelMessages.update_success_msg.message);
           this.commonService.showModalValidate(this.labelMessages.update_success_msg.message,'',this.messageLabel.static_messages.info,this.labelMessages.update_success_msg.message);
            this.commonService.ogLog('module', this.createModuleForm.value);
            this.commonService.add_Update_MenuOrderList(this.createModuleForm.value.menuId, this.createModuleForm.value.menuId, this.createModuleForm.value.moduleorderId,
              KEYS.menuParent.defaultID, this.pagetype, 'Y', this.createModuleForm.value.isHide, 1).subscribe((data: any) => {
              });
            this.router.navigate([this.routePath.dashboard]);
          });
      }

    } else {
      if (isBlank(this.createModuleForm.value.menuName)) {
       // this.toastr.warning(this.labelMessages.module_creation.module_name);
       this.commonService.showModalValidate(this.labelMessages.module_creation.module_name,'',this.messageLabel.static_messages.info,this.labelMessages.module_creation.module_name);
      }
    }
  }

  loadAppPageList() {
    this.appPageList = [];
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.commonService.loadAppPageList(dbFullPath, this.commonService.getUserCredentials(KEYS.credential_customer_id)).subscribe((data: any) => {
      this.commonService.ogLog('data : ', data);
      if (isData(data)) {
        data['table'].forEach((element: any) => {
          this.appPageList.push({
            'id': element.gstibo_page_id,
            'name': element.gstibo_page_name
          });
        });
      }
    });
  }
}
